/** Tracks in-flight checkout payments — defers PWA SW refresh while active (M-06). */

let paymentPendingCount = 0;
let pendingRefreshCallback: (() => void) | null = null;

export function isPaymentPending(): boolean {
  return paymentPendingCount > 0;
}

export function setPaymentPending(active: boolean): void {
  if (active) {
    paymentPendingCount += 1;
    return;
  }
  paymentPendingCount = Math.max(0, paymentPendingCount - 1);
  if (paymentPendingCount === 0 && pendingRefreshCallback !== null) {
    const callback = pendingRefreshCallback;
    pendingRefreshCallback = null;
    callback();
  }
}

export function queuePwaRefreshWhenIdle(refresh: () => void): void {
  if (!isPaymentPending()) {
    refresh();
    return;
  }
  pendingRefreshCallback = refresh;
}

export function resetPaymentPendingGateForTests(): void {
  paymentPendingCount = 0;
  pendingRefreshCallback = null;
}
